<template>
    <o-table :title="$t('sandoz.warehouse_import_jobs')" ref="tableList" url="/api/sandoz/warehouse_import_jobs" :enable-new="false"
             :enable-delete="false" :enable-edit="false" :enable-view="true"
             default-sort-by-direction="desc" default-sort-by="id">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-select :items="stateList" :title="$t('sandoz.status')" column="status"></o-filter-select>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('core.id')}}</o-table-header>
            <o-table-header column="created_at">{{$t('sandoz.date')}}</o-table-header>
            <o-table-header column="status">{{$t('sandoz.status')}}</o-table-header>
            <o-table-header column="duration_seconds">{{$t('sandoz.duration')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.created_at | formatDatetime }}</td>
            <td>
                <b-badge :variant="statusVariant(props.item.status)">
                    {{ props.item.status ? $t('sandoz.' + props.item.status) : '' }}
                </b-badge>
            </td>
            <td>{{ formatDuration(props.item.duration_seconds) }}</td>
        </template>
    </o-table>
</template>

<script>
    export default {
        data: () => ({
            stateList: []
        }),
        created() {
            this.stateList = [
                {value: 'running', text: this.$i18n.t('sandoz.running')},
                {value: 'failed', text: this.$i18n.t('sandoz.failed')},
                {value: 'successful', text: this.$i18n.t('sandoz.successful')},
            ]
        },
        methods: {
            formatDuration(seconds) {
                if (seconds === null || seconds === undefined) return '-'
                if (seconds < 60) return seconds + 's'
                const minutes = Math.floor(seconds / 60)
                const remainingSeconds = seconds % 60
                return minutes + 'm ' + remainingSeconds + 's'
            },
            statusVariant(status) {
                switch (status) {
                    case 'successful': return 'success'
                    case 'failed': return 'danger'
                    case 'running': return 'warning'
                    default: return 'secondary'
                }
            }
        }
    }
</script>
